import { CustomLessonViewTag as CustomLessonViewTagType } from '@yandex-int/k-common';
import React from 'react';

import { CustomLessonViewTag } from '../__tag/custom-lesson-view__tag';

import './custom-lesson-view__tags.scss';

interface Props {
    tags: Array<CustomLessonViewTagType>;
}

export const CustomLessonViewTags = React.memo(({ tags }: Props) => {
    return (
        <div className="custom-lesson-view__tags">
            {tags.map((tag) => (
                <CustomLessonViewTag key={tag.slug} tag={tag} />
            ))}
        </div>
    );
});
